import { render, staticRenderFns } from "./AppointmentDayCard.vue?vue&type=template&id=2b4095b2"
import script from "./AppointmentDayCard.vue?vue&type=script&lang=js"
export * from "./AppointmentDayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports